<template>
  <div class="menu-content-employee">
    <div v-if="hasRoutes" class="menu-routes">
      <slot name="routes" :routes="displayRoutes" :is-expanded="isExpanded">
        <RoutesList :routes="displayRoutes" :variant="isExpanded ? 'default' : 'compact'" />
      </slot>
    </div>

    <div v-else-if="!hasRoutes" class="empty-state">
      <slot name="empty"> </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserRoutes } from '@/common/composables/useUserRoutes';
import RoutesList from '@/layouts/components/RoutesList.vue';

interface Props {
  isExpanded: boolean;
}

defineProps<Props>();

const { displayRoutes, hasRoutes } = useUserRoutes();
</script>

<style scoped>
.menu-content-employee {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.menu-routes {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--ion-color-medium) transparent;
}

.menu-routes::-webkit-scrollbar {
  width: 4px;
}

.menu-routes::-webkit-scrollbar-track {
  background: transparent;
}

.menu-routes::-webkit-scrollbar-thumb {
  background-color: var(--ion-color-medium);
  border-radius: 2px;
}

.menu-routes::-webkit-scrollbar-thumb:hover {
  background-color: var(--ion-color-medium-shade);
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: var(--ion-color-medium);
}
</style>
